import React, { lazy } from 'react';
import ReactDOM from 'react-dom/client';
// config i18n
import { overrideFunctionArrayAt } from './override';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

overrideFunctionArrayAt();
const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

const BaseProvider = lazy(() =>
    import('./BaseProvider').then(({ BaseProvider }) => ({
        default: BaseProvider,
    }))
);

root.render(
    <React.StrictMode>
        <BaseProvider />
    </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
